// removed by extract-text-webpack-plugin
module.exports = {"icon":"AddFilterBox__icon___2CJMs","addText":"AddFilterBox__addText___1_HwZ","addFilterContainer":"AddFilterBox__addFilterContainer___PLa95","addIcon":"AddFilterBox__addIcon____WiTh"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/users/components/advancedSearch/AddFilterBox.scss
// module id = 1657
// module chunks = 0